import { SellerAddressUi } from '@/components/Seller/SellerProfile/Address/SellerAddressUi';
import { SellerAddressResponse } from '@/data/api/model/sellers/SellersDto';

export function sellerAddressResponseToSellerAddressUi(
  input: SellerAddressResponse
): SellerAddressUi {
  return {
    street: input.street ?? '',
    exteriorNumber: input.exterior_number ?? '',
    interiorNumber: input.interior_number ?? '',
    postalCode: input.zip_code ?? '',
    colonia: input.colony ?? '',
    saveDisabled: true,
    cancelDisabled: true,
  };
}
